import { FC, useMemo } from "react";
import SearchIcon from "@mui/icons-material/Search";
import { Stack, Divider, TextField, InputAdornment, CircularProgress } from "@mui/material";
import { ReduxState } from "ra-core";
import { useSelector } from "react-redux";
import { useUserInvitationsTableSearchContext } from "./UserInvitationsTableSearchProvider";
import SearchCriteriaChips, { ChipItem } from "~/components/input/SearchCriteriaChips";
import { PopBaseFilter } from "~/components/input/PopAutocompleteFilter";
import { RoleResponseDto } from "~/gen/api/user";
import { useUserManageAmbientDataContext } from "./UserManageAmbientDataContextProvider";


const UserInvitationsTableSearchRegion: FC = () => {
  const {
    states,
    setSearchRole,
  } = useUserInvitationsTableSearchContext()

  const criteriaChips = useMemo(() => {
    const arr = [] as ChipItem[][]
    if (states.roles.length > 0) {
      arr.push(states.roles.map(r => ({
        id: `c_${r.isDefault ? 0 : 1}${r.roleId}`,
        label: 'Role',
        content: r.name!,
        delete: () => setSearchRole(r, true)
      })))
    }
    return arr
  }, [setSearchRole, states])

  return (
    <>
      <Stack direction="row" flexWrap="wrap" alignItems="center" sx={{ p: 2, pl: 4, m: -1}}>
        <SearchEmailField />
        <PopRoleFilter />
      </Stack>
      <Divider />
      <SearchCriteriaChips criteriaChips={criteriaChips} />
    </>
  )
}

export default UserInvitationsTableSearchRegion;


const SearchEmailField : FC = () => {
  const loading = useSelector<ReduxState, boolean>(store => !!store.admin.loading)
  const {
    states: {email},
    searchEmail,
  } = useUserInvitationsTableSearchContext()
  return (
    <TextField 
      id="userinvitationstable-search-name"
      placeholder='Search by Email'
      fullWidth
      size="small"
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            {loading ? <CircularProgress size={20} /> : <SearchIcon fontSize="small" />}
          </InputAdornment>
        )
      }}
      onChange={(e) => searchEmail(e.target.value)}
      value={email}
      variant="outlined"
      sx={{ width: 280, mr: 'auto' }}
    />
  )
}


const PopRoleFilter: FC = () => {
  const {roles} = useUserManageAmbientDataContext()
  const { setSearchRole } = useUserInvitationsTableSearchContext()
  return (
    <PopBaseFilter 
      label="Role"
      id='user-role-picker'
      options={roles}
      onChange={(event, option) => {
        const rItem = option as RoleResponseDto
        if (rItem) {
          setSearchRole(rItem, false)
        }
      }}
    />
  )
}
